import {
  apiRegister,
  // loadJsonp,
  ssoJump
} from '../../common/api'
import { isOkMobile, isOkMobCode, isOkPassword, isOkNick } from '../../utils/wz'
import {
  ERR_REQ_MOBILE,
  ERR_REQ_NICKCODE,
  NO_ERROR,
  ERR_REQ_MOBCODE,
  LOGIN_CROP_XS,
  ERR_REP_NOT_LOGIN,
  MOBCODE_TYPE_SMS,
  ERR_REQ_PWD
} from '../../const'
import { XEnv, XUtils } from '../../common/globals'
// import {
//   map
// } from '../../utils/base'

export const mobCodeForReg = apiRegister('mobCodeForReg', {
  protoId: 20,
  path: '/passport/mobcode/',
  cdUri: 15000, //冷却时长:60 * 1000毫秒
  checkQuery: function(query) {
    if (!isOkMobile(query.mobile, query.mobCountry)) {
      return ERR_REQ_MOBILE
    }
    return NO_ERROR
  },
  formatQuery: function(query) {
    const mobCountry = query.mobCountry || '+86'
    const type = query.type || MOBCODE_TYPE_SMS
    return {
      ...query,
      corp: LOGIN_CROP_XS,
      mobCountry,
      type
    }
  }
}).send

export const mobCodeForLogin = apiRegister('mobCodeForLogin', {
  protoId: 627,
  path: '/passport/mobcodeforlogin/',
  cdUri: 15000, //冷却时长:60 * 1000毫秒
  checkQuery: function(query) {
    if (!isOkMobile(query.mobile, query.mobCountry)) {
      return ERR_REQ_MOBILE
    }
    return NO_ERROR
  },
  formatQuery: function(query) {
    const mobCountry = query.mobCountry || '+86'
    return {
      ...query,
      corp: LOGIN_CROP_XS,
      mobCountry
    }
  }
}).send

export const regForPwd = apiRegister('regForPwd', {
  protoId: 22,
  path: '/passport/register/',
  checkQuery: function(query) {
    if (!isOkMobile(query.mobile, query.mobCountry)) {
      return ERR_REQ_MOBILE
    } else if (!isOkMobCode(query.mobCode)) {
      return ERR_REQ_MOBCODE
    } else if (!isOkPassword(query.password)) {
      return ERR_REQ_PWD
    }
    return NO_ERROR
  },
  formatQuery: function(query) {
    const mobCountry = query.mobCountry || '+86'
    const makeCookie = query.makeCookie === 0 ? 0 : 1
    const syncLogin = query.syncLogin === 0 ? 0 : 1
    const pCode = query.pCode || ''
    // TODO: 待移除对XEnv的依赖
    const fromSource = XEnv.isMobile ? 'mobile' : 'pc'
    return {
      ...query,
      corp: LOGIN_CROP_XS,
      makeCookie,
      syncLogin,
      mobCountry,
      pCode,
      fromSource
    }
  }
}).send

export const loginForMob = apiRegister('loginForMob', {
  protoId: 24,
  path: '/passport/login/',
  checkQuery: function(query) {
    if (!isOkMobCode(query.mobCode)) {
      return ERR_REQ_MOBCODE //参数错误
    } else if (!isOkMobile(query.mobile, query.mobCountry)) {
      return ERR_REQ_MOBILE //参数错误
    }
    return NO_ERROR
  },
  formatQuery: function(query) {
    const mobCountry = query.mobCountry || '+86'
    return {
      ...query,
      corp: LOGIN_CROP_XS,
      loginType: 1,
      makeCookie: 1,
      mobCountry
    }
  }
}).send

export const loginForPwd = apiRegister('loginForPwd', {
  protoId: 24,
  path: '/passport/login/',
  checkQuery: function(query) {
    if (!isOkMobile(query.mobile, query.mobCountry)) {
      return ERR_REQ_MOBILE
    }
    return NO_ERROR
  },
  formatQuery: function(query) {
    const mobCountry = query.mobCountry || '+86'
    return {
      ...query,
      corp: LOGIN_CROP_XS,
      loginType: 0,
      makeCookie: 1,

      mobCountry
    }
  }
}).send

//上传头像
export const uploadPhoto = apiRegister('uploadPhoto', {
  protoId: 31,
  isHcb: true,
  path: '/user/logo-add/'
  // checkQuery: function (query) {

  //   return NO_ERROR
  // },
  // formatQuery: function(query) {}
}).submit

/*
30	user	/user/updateinfo/	设置用户基本信息
参数名称	参数类型	说明
gender	int	(可选) 0隐藏 1男 2 女
birthday	date	(可选) 生日 2012-01-22
nick	string	(可选) 用户昵称只能是字母数字中文下划线组合，且开头不能是数字和下划线，最小长度不少于4个字节（注意不是字符，通常一个utf8字符占3个字节），最大不超过32个字节 (一个月内只能修改一次)
tel	string(0-32)	(可选) 办公电话 010-89898222-001
address	string(0-1024)	(可选) 用户地址
area	string(0-32)	(可选) 所在区域 86,09,32,98(由区域id拼接,逗号连接)
*/
export const loginUpdateInfo = apiRegister('loginUpdateInfo', {
  protoId: 30,
  path: '/user/updateinfo/',
  checkQuery: function(query) {
    if (!isOkNick(query.nick)) {
      return ERR_REQ_NICKCODE
    }
    return NO_ERROR
  },
  formatQuery: function(query) {
    query = XUtils.assign({}, query)
    if (!query.hasOwnProperty('makeCookie')) {
      query.makeCookie = 1
    }
    return query
  }
  // formatResult: function(Result) {}
}).send

export const logoutForAll = apiRegister('logoutForAll', {
  protoId: 56,
  path: '/passport/logout/'
}).send

export async function regSend(params) {
  const R = await regForPwd(params)
  await ssoJump(R.ssoUrls)
  return R
}

export async function loginSend(params) {
  const { loginType } = params
  const send = loginType === 1 ? loginForMob : loginForPwd
  const R = await send(params)
  await ssoJump(R.ssoUrls)
  return R
}

export async function logoutSend(params) {
  let R = {}
  try {
    R = await logoutForAll(params)
    await ssoJump(R.ssoUrls)
  } catch (e) {
    if (e.code !== ERR_REP_NOT_LOGIN) {
      throw e
    }
  }
  return R
}
